import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext'; // Assuming correct path to AuthContext
import { Loader2 } from 'lucide-react'; // Example of a loading icon

const ProtectedRoute = ({ allowedRoles }) => {
    const { isAuthenticated, userRole, isLoading } = useAuth();
    const location = useLocation();

    // 1. Loading State Check
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-950">
                <div className="flex flex-col items-center">
                    {/* Animated loading spinner, styled to match the MVP aesthetic */}
                    <Loader2 className="w-10 h-10 animate-spin text-teal-400 mb-4" />
                    <p className="text-gray-400">Verifying access token...</p>
                </div>
            </div>
        );
    }

    // 2. Authentication Check (User must be logged in)
    if (!isAuthenticated) {
        // Redirect non-authenticated users to the Login page,
        // storing the current location to redirect back after successful login.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Authorization Check (User must have an allowed role)
    // Check if the userRole is in the list of allowedRoles for this route
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Redirect unauthorized users (e.g., non-admin trying to access /admin)
        // to the main dashboard or a standard unauthorized page.
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-950 p-6">
                <div className="text-center p-10 bg-gray-800 rounded-xl border border-red-600 shadow-2xl">
                    <h1 className="text-4xl font-bold text-red-500 mb-4">ACCESS DENIED</h1>
                    <p className="text-lg text-gray-300 mb-6">
                        You do not have the required permissions for this **Developer Portal** area.
                    </p>
                    <Navigate to="/dashboard" replace={true} />
                </div>
            </div>
        );
    }

    // 4. Success: User is authenticated and authorized, render the child route
    return <Outlet />;
};

export default ProtectedRoute;
